import KunLoading73 from './src/index'

KunLoading73.install = function (Vue) {
	Vue.component(KunLoading73.name, KunLoading73);
}

export default KunLoading73;
